export const UNDERSCORE = '_'
export const DASH = '-'
export const SPACE = ' '
export const EMPTY_STRING = ''
export const EMPTY_SPACE_STRING = ' '
export const COMMA = ','
export const DOT = '.'
export const COLON = ':'
export const SEMICOLON = ';'
export const SLASH = '/'
export const BACKSLASH = '\\'
export const PIPE = '|'
export const DOUBLE_QUOTE = '"'
export const SINGLE_QUOTE = "'"
